export default __webpack_public_path__ + "01eb0f8dcf104b7fac1653626cc47bf6.png";